import { env } from '@fiverr-private/futile';
import { localStorage } from '@fiverr-private/futile/lib/storage/localStorage';

const KEYS = {
    BROWSER_HISTORY: 'browse-history',
    FIVERR_CHOICE_MODALITIES_TOOLTIP: 'search_fiverr_choice_modalities_tooltip'
};

const ssrStorageMock = {
    [KEYS.BROWSER_HISTORY]: [],
    [KEYS.FIVERR_CHOICE_MODALITIES_TOOLTIP]: true
};

const defaultStorage = {
    [KEYS.BROWSER_HISTORY]: [],
    [KEYS.FIVERR_CHOICE_MODALITIES_TOOLTIP]: false
};

const GIGS_REGEX = /gigs\|\|\|show\|\|\|([\d]+)/;

const get = (key) => {
    if (!env.browser) {
        return ssrStorageMock[key];
    }

    return localStorage.get(key) || defaultStorage[key];
};

const set = (key, value) => {
    if (env.browser) {
        return localStorage.set(key, value);
    }
};

const getRecentlyViewedGigs = () => get(KEYS.BROWSER_HISTORY)
    .reduce((acc, data) => {
        const match = data.match(GIGS_REGEX);
        if (match) {
            acc.push(match[1]);
        }
        return acc;
    }, []);

const removeAllRecentlyViewedGigs = () => {
    const updatedHistory = get(KEYS.BROWSER_HISTORY)
        .filter((entry) => !entry.match(GIGS_REGEX));

    return set(KEYS.BROWSER_HISTORY, updatedHistory);
};

const removeSingleRecentlyViewedGig = (gigId) => {
    const gigIdString =gigId.toString();
    const updatedHistory = get(KEYS.BROWSER_HISTORY)
        .filter((entry) => {
            const match = entry.match(GIGS_REGEX);
            return !(match && match[1] === gigIdString);
        });

    return set(KEYS.BROWSER_HISTORY, updatedHistory);
};

const storePageView = (entrySuffix) => {
    const filteredBrowseHistory = get(KEYS.BROWSER_HISTORY)
        .filter((entry) => !entry.includes(entrySuffix));

    const newEntry = Date.now() + entrySuffix;
    filteredBrowseHistory.push(newEntry);

    return set(KEYS.BROWSER_HISTORY, filteredBrowseHistory);
};

export default { get, set, getRecentlyViewedGigs, removeAllRecentlyViewedGigs, removeSingleRecentlyViewedGig, storePageView, KEYS };
